/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Controls whether Ampersand branding is removed from the embeddable UI components.
 * @export
 * @interface ProjectEntitlementsBrandingRemoval
 */
export interface ProjectEntitlementsBrandingRemoval {
    /**
     * True if Ampersand branding has been removed for this project.
     * @type {boolean}
     * @memberof ProjectEntitlementsBrandingRemoval
     */
    value: boolean;
}

/**
 * Check if a given object implements the ProjectEntitlementsBrandingRemoval interface.
 */
export function instanceOfProjectEntitlementsBrandingRemoval(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function ProjectEntitlementsBrandingRemovalFromJSON(json: any): ProjectEntitlementsBrandingRemoval {
    return ProjectEntitlementsBrandingRemovalFromJSONTyped(json, false);
}

export function ProjectEntitlementsBrandingRemovalFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectEntitlementsBrandingRemoval {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function ProjectEntitlementsBrandingRemovalToJSON(value?: ProjectEntitlementsBrandingRemoval | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

